import { useTranslations } from 'next-intl';

import Text from '@commons/components/Text';
import Grid from '@commons/containers/Grid';
import PageBuilder from '@commons/pagebuilder';
import type { MemberNodeProps } from '@commons/pagebuilder/nodes/Member';
import type { DrupalView } from '@commons/types/drupal';

/**
 * Enum of displays for the AiiA members view.
 */

export enum AIIA_MEMBERS_VIEW_DISPLAY {
  Grid = 'grid_block',
}

/**
 * Type definition for the AiiA members view.
 */

export type DrupalAiiaMembersView = DrupalView<MemberNodeProps>;

/**
 * AiiA Members view component.
 */

const MembersView = (props: DrupalAiiaMembersView) => {
  const t = useTranslations('views');

  switch (props.display) {
    default:
    case AIIA_MEMBERS_VIEW_DISPLAY.Grid:
      if (!props.content || props.content.length === 0) {
        return <Text marginBottom="none">{t('noResult')}</Text>;
      }

      return (
        <Grid
          columns={{ xs: 1, md: 2, lg: 3, xl: 4 }}
          rowGap={{ xs: 'xs', md: 'xl' }}
          columnGap="md"
        >
          {props.content.map(PageBuilder.renderNode)}
        </Grid>
      );
  }
};

export default MembersView;
